import { ThemeOptions } from '@mui/material';

export const baseOptions: ThemeOptions = {
    typography: {
        fontFamily: 'Manrope',
    },
};